import {
	Box,
	SxProps,
	TextField,
	TextFieldProps,
	Theme,
	Typography,
	TypographyProps,
} from '@mui/material';
import React from 'react';

const Bod1 = ({ text, sx }: { text: string; sx?: SxProps }) => (
	<Typography variant="body1" sx={sx}>
		{text}
	</Typography>
);

type HeaderConfig = [text: string, variant: TypographyProps['variant']];

type TextFieldWithCounterProps = {
	headerText?: HeaderConfig;
	text: string;
	charMin?: number;
	charMax?: number;
	showCharCounter?: boolean;
	onChange?: TextFieldProps['onChange'];
	helperText?: string;
	errorConditions?: boolean[];
	textFieldSx?: SxProps<Theme>;
	componentSx?: SxProps<Theme>;
	readOnly?: boolean;
	disabled?: boolean;
};

const TextFieldWithCounter = ({
	headerText,
	text,
	charMin = 0,
	charMax,
	showCharCounter = true,
	onChange,
	helperText,
	errorConditions = [],
	textFieldSx,
	componentSx,
	readOnly = false,
	disabled = false,
}: TextFieldWithCounterProps): React.JSX.Element => {
	const [headerLabel, headerVariant] = headerText ?? [];
	const charMinCondition =
		charMin > 0 && text.length > 0 && text.length < charMin;
	const hasError = errorConditions.some(Boolean) || charMinCondition;
	return (
		<Box sx={componentSx}>
			{headerText && (
				<Typography id="header" variant={headerVariant}>
					{headerLabel}
				</Typography>
			)}
			<TextField
				fullWidth
				disabled={disabled}
				id="text-field"
				value={text}
				onChange={onChange}
				error={hasError}
				helperText={
					charMinCondition
						? `Minimum ${charMin} characters required`
						: helperText
				}
				slotProps={{
					htmlInput: { maxLength: charMax, readOnly: readOnly },
				}}
				sx={textFieldSx}
			/>
			{showCharCounter && (
				<Bod1
					text={
						charMax
							? `${text.length} / ${charMax}`
							: `${text.length}`
					}
					sx={{
						textAlign: 'right',
						marginRight: 0.5,
						opacity: 0.5,
					}}
				/>
			)}
		</Box>
	);
};

export default TextFieldWithCounter;
